import { render } from "./DownloadSvg.vue?vue&type=template&id=974cc03c&bindings={}"
import script from "./DownloadSvg.vue?vue&type=script&lang=ts"
export * from "./DownloadSvg.vue?vue&type=script&lang=ts"
script.render = render

export default script